import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import TooltipView from 'echarts/lib/component/tooltip/TooltipView';
import { noop } from 'zrender/lib/core/util.js';

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterinit', () => {
    class TooltipViewPlus extends TooltipView {
      dvImmediatelyHideTip() {
        const tooltipContent = (this as any)._tooltipContent;
        tooltipContent.hide();
        // 清除相关状态属性，使用 any 访问私有属性
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        (this as any)._lastX = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        (this as any)._lastY = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        (this as any)._lastDataByCoordSys = null;
      }
    }
    registers.registerAction(
      {
        type: 'dvImmediatelyHideTip',
        event: 'dvImmediatelyHideTip',
        update: 'tooltip:dvImmediatelyHideTip'
      },
      noop
    );

    // @ts-ignore: TypeScript 无法正确识别 ECharts 的组件注册机制
    registers.registerComponentView(TooltipViewPlus);
  });
}
